import React from 'react';
import Icon from '@atlaskit/icon';
import { CustomGlyphProps } from '@atlaskit/icon/types';

import { IconProps } from './interface';

const CircleGroupGlyph = (props: CustomGlyphProps) => (
    <svg
        width="5"
        height="14"
        viewBox="0 0 5 14"
        data-testid={props['data-testid']}
        aria-label={props['aria-label']}
        className={props.className}>
        <circle cx="1" cy="1" r="1" fill="currentColor"/>
        <circle cx="4" cy="1" r="1" fill="currentColor"/>
        <circle cx="1" cy="4" r="1" fill="currentColor"/>
        <circle cx="4" cy="4" r="1" fill="currentColor"/>
        <circle cx="1" cy="7" r="1" fill="currentColor"/>
        <circle cx="4" cy="7" r="1" fill="currentColor"/>
        <circle cx="1" cy="10" r="1" fill="currentColor"/>
        <circle cx="4" cy="10" r="1" fill="currentColor"/>
        <circle cx="1" cy="13" r="1" fill="currentColor"/>
        <circle cx="4" cy="13" r="1" fill="currentColor"/>
    </svg>

);

const CircleGroupIcon = (props: IconProps) => {
    return <Icon {...props}  glyph={CircleGroupGlyph} label={props.label ?? ''}/>;
};

export default CircleGroupIcon;